module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_03_1400.03d9c598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_03_1400.jpg
// module id = 350
// module chunks = 0